import { makeStyles } from 'tss-react/mui';

const name = 'MarkdownWrapper';

export const useMarkdownWrapperStyles = makeStyles({ name })(theme => ({
  ol: {
    paddingLeft: theme.spacing(5),
  },
  p: {
    margin: 0,
  },
  ul: {
    paddingLeft: theme.spacing(5),
  },
}));
